import { render, staticRenderFns } from "./PricePumaPromoDashboard.vue?vue&type=template&id=24f0540e&scoped=true&"
import script from "./PricePumaPromoDashboard.vue?vue&type=script&lang=js&"
export * from "./PricePumaPromoDashboard.vue?vue&type=script&lang=js&"
import style0 from "./PricePumaPromoDashboard.vue?vue&type=style&index=0&id=24f0540e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24f0540e",
  null
  
)

export default component.exports